
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Playground } from 'docz';
import PropsTable from './docs/PropsTable';
import { COMMON, LAYOUT } from './docs/system_props';
import { Dropdown } from './Dropdown';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "dropdown"
    }}>{`Dropdown`}</h1>
    <h2 {...{
      "id": "default"
    }}>{`Default`}</h2>
    <Playground __position={0} __code={'() => {\n  const [isOpen, setIsOpen] = React.useState(false)\n  return (\n    <Dropdown>\n      <button onClick={() => setIsOpen(wasOpen => !wasOpen)}>\n        Click here\n      </button>\n      {isOpen && (\n        <Dropdown.Menu bg=\"white\">\n          <div>Here is the menu</div>\n          <div>* Item 1</div>\n          <div>* Item 2</div>\n          <div>* Item 3</div>\n        </Dropdown.Menu>\n      )}\n    </Dropdown>\n  )\n}'} __scope={{
      props: this ? this.props : props,
      Playground,
      PropsTable,
      COMMON,
      LAYOUT,
      Dropdown
    }} __codesandbox={`undefined`} mdxType="Playground">
  {() => {
        const [isOpen, setIsOpen] = React.useState(false);
        return <Dropdown mdxType="Dropdown">
        <button onClick={() => setIsOpen(wasOpen => !wasOpen)}>Click here</button>
        {isOpen && <Dropdown.Menu bg="white">
            <div>Here is the menu</div>
            <div>* Item 1</div>
            <div>* Item 2</div>
            <div>* Item 3</div>
          </Dropdown.Menu>}
      </Dropdown>;
      }}
    </Playground>
    <h3 {...{
      "id": "props"
    }}>{`Props`}</h3>
    <PropsTable mdxType="PropsTable">{[...COMMON, ...LAYOUT]}</PropsTable>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;